import React from "react";
import { connect } from "react-redux";

const Resources = {
  syncAction: {
    show: "notificationShow",
    remove: "notificationRemove"
  },
  type: ["info", "success", "error", "warning"]
};

function RemoveNotification() {
  const {
    syncAction: { remove }
  } = Resources;
  return dispatch => {
    dispatch({ type: remove });
  };
}

export function showNotification(message, type) {
  const {
    syncAction: { show }
  } = Resources;
  return dispatch => {
    dispatch({ type: show, payload: { message, type, show: true } });
  };
}

function Notification(props) {
  function remove() {
    setTimeout(props.RemoveNotification, 4 * 1000);
  }
  if (props.notification.show) {
    remove();
    return (
      <div
        id="notification_toast-flash"
        className={`notification_toast ${props.notification.type} animated fadeInUp`}
      >
        <p>{props.notification.message}</p>
      </div>
    );
  }
  return null;
}

export default connect(
  state => ({ notification: state.NotificationReducer }),
  { RemoveNotification }
)(Notification);

const initialState = {
  show: false,
  message: "hello",
  type: "info"
};

export function NotificationReducer(state = initialState, { type, payload }) {
  const { show, remove } = Resources.syncAction;
  switch (type) {
    case show:
      return {
        ...payload
      };

    case remove:
      return {
        show: false,
        message: undefined,
        type: "info"
      };

    default:
      return state;
  }
}
